<template>
  <div>
    Placeholder for embed view
  </div>
</template>

<script>
export default {
  name: 'Embed'
}
</script>
